// @ts-nocheck
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, EventEmitter, OnDestroy, TemplateRef } from '@angular/core';
import { NavigationHelper } from '../../../helpers/navigationClass';
import { ModalOverlayComponent } from './modal.component';

@Directive({
  selector: '[lbcaControllerModal]',
})
export class ModalDirective extends NavigationHelper implements OnDestroy {
  private subscription: any = null;
  private modalSubscription: any = null;

  constructor(
    private overlay: Overlay,
    private instanceModalInterface: ModalInterfaceComunication
  ) {
    super();
    this.initSubscriptionModalController();
  }

  public override onWindowChange(): void {
    this.instanceModalInterface.closeModal();
    this.subscription.unsubscribe();
    if (this.modalSubscription) this.modalSubscription.unsubscribe();
  }

  ngOnDestroy(): void {
    this.instanceModalInterface.closeModal();
    this.subscription.unsubscribe();
    if (this.modalSubscription) this.modalSubscription.unsubscribe();
  }

  private initSubscriptionModalController(): void {
    let overlayRef: any = null;
    this.subscription = this.instanceModalInterface.modalControllerEmmiter.subscribe(
      (event: eventController) => {
        if (event.prop === 'isShouldShowModal') {
          if (event.value)
            overlayRef = this.showModal(
              ModalOverlayComponent,
              overlayRef,
              this.overlay,
              event.complement
            );
          else overlayRef = this.closeModal(overlayRef);
        }
      }
    );
  }

  private createOverlayRef(overlay: Overlay, modalProperties: modalProps): OverlayRef {
    const positionStrategy =
      modalProperties.position === 'center'
        ? this.overlay.position().global().centerHorizontally().centerVertically()
        : this.overlay.position().global().right('0');
    const options: any = {
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'bg-transparent',
    };
    if (modalProperties.scrollStrategy == 'block') {
      options.scrollStrategy = this.overlay.scrollStrategies.block();
    }
    const config = new OverlayConfig(options);

    return overlay.create(config);
  }

  private showModal(
    component: any,
    overlayRef: OverlayRef,
    overlay: Overlay,
    templateRef: TemplateRef<Record<string, unknown>>
  ): OverlayRef {
    const modalProperties = this.instanceModalInterface.modalProperties;
    const { backdropClick, backdropClickBehaviour } = modalProperties;
    document.getElementById('main-scroll')!.classList.add('blur');

    if (!overlayRef) overlayRef = this.createOverlayRef(overlay, modalProperties);
    if (overlayRef && overlayRef.hasAttached()) return null as any;

    const ref: any = overlayRef.attach(new ComponentPortal(component));
    ref.instance.templateRef = templateRef;
    ref.instance.modalProperties = modalProperties;

    if (backdropClick)
      this.modalSubscription = overlayRef.backdropClick().subscribe(() => {
        if (backdropClickBehaviour) {
          backdropClickBehaviour();
        } else {
          this.closeModal(overlayRef);
        }
      });

    return overlayRef;
  }

  private closeModal(overlayRef: any): any {
    if (!overlayRef) return null;
    if (this.modalSubscription) this.modalSubscription.unsubscribe();

    const modalProperties = this.instanceModalInterface.modalProperties;
    const animationScapeModal = modalProperties?.position === 'right' ? 'hideModal' : 'closeModal';

    overlayRef.overlayElement.classList.add(animationScapeModal);

    document.getElementById('main-scroll')!.classList.remove('blur');

    setTimeout(() => {
      overlayRef.detach();
      overlayRef.overlayElement.classList.remove(animationScapeModal);
      return null;
    }, 700); // hideModal motion delay
    return null;
  }
}

const DEFAULT_PROPERTIES: modalProps = {
  backdropClick: true,
  position: 'right',
};
export class ModalInterfaceComunication {
  public modalControllerEmmiter = new EventEmitter();

  public modalProperties: modalProps = {};

  public showModal(templateRef: TemplateRef<any>, modalProperties?: modalProps): void {
    this.modalProperties = { ...DEFAULT_PROPERTIES, ...modalProperties };
    this.modalControllerEmmiter.emit({
      prop: 'isShouldShowModal',
      value: true,
      complement: templateRef,
    });
  }

  public closeModal(): void {
    this.modalControllerEmmiter.emit({ prop: 'isShouldShowModal', value: false });
  }
}

interface eventController {
  prop: string;
  value: any;
  complement?: any;
}
interface modalProps {
  position?: 'right' | 'center';
  removeStyle?: boolean;
  width?: 'right-small';
  backdropClick?: boolean;
  backdropClickBehaviour?: backdropClickBehaviourFunction;
  scrollStrategy?: string;
}
interface backdropClickBehaviourFunction {
  (event?: Event): void;
}
